import React from 'react';
import styled from '@emotion/styled';
import { formatListForTooltip, BaseOverflowBadgeProps } from './ListOverflowBadge';
import HiddenItemsCount from './HiddenItemsCount';
import ConditionalTooltip from '../ConditionalTooltip/ConditionalTooltip';

export type StaticBadgeProps = BaseOverflowBadgeProps & { show: number };

const StaticBadge = ({ list, delineated = false, show = 1, tooltipDisplay }: StaticBadgeProps) => {
  return (
    <Wrapper>
      {list.slice(0, show).map((item, index) => (
        <div key={index}>
          {item}
          {delineated && index < show - 1 ? ',' : ''}
        </div>
      ))}
      {list.length > show && (
        <ConditionalTooltip show={!!tooltipDisplay} title={formatListForTooltip(tooltipDisplay, list)}>
          <HiddenItemsCount>+{list.length - show}</HiddenItemsCount>
        </ConditionalTooltip>
      )}
    </Wrapper>
  );
};

export default StaticBadge;

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
`;
